/*
 * @Descripttion: 商品报备页State
 * @Author: cb4786
 * @Date: 2023-08-30 09:49:12
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-12-17 15:01:09
 */

import { ActionType, CustomAction } from '../../global'
import { oaUserItem } from '../../api/Filing'
import { SearchItem } from '../../components/Search'
import { fileFile } from '../../modules/uploadfiles/hooks'

export interface State {
  dataSource: any[]
  dataSourceLoading: boolean
  deleteParam: any[]
  goodsCode: number
  staffModalVisible: boolean
  searchdata: SearchItem
  userListdataSource: oaUserItem[]
  userListdataSourceLoading: boolean
  disabledOperate: boolean
  displayTip: boolean
  fillingSheetState: { state: string; approvalOpinion: string }
  isImportModalVisible: boolean
  isImportModalConfirmBtnLoading: boolean
  uploadFilesList: fileFile[]
  originFile: any
  importLoadingTip: boolean
  dockingSalesJobNumber: string
  platformList: any[]
}
export const defaultState: State = {
  dataSource: [],
  dataSourceLoading: false,
  deleteParam: [],
  goodsCode: 0,
  staffModalVisible: false,
  searchdata: {},
  userListdataSource: [],
  userListdataSourceLoading: false,
  disabledOperate: false,
  displayTip: false,
  fillingSheetState: { state: '审核中', approvalOpinion: '' },
  isImportModalVisible: false,
  isImportModalConfirmBtnLoading: false,
  uploadFilesList: [],
  originFile: {},
  importLoadingTip: false,
  dockingSalesJobNumber: '',
  platformList: [],
}

type Action = ActionType<State>

// 默认 Reducer
export default function reducer(state: State, action: CustomAction<Action>) {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload
      return arr
    case 'setGoodsCodeAction':
      arr.goodsCode = action.payload
      return arr
    case 'setDeleteParamAction':
      arr.deleteParam = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'setStaffModalVisibleAction':
      arr.staffModalVisible = action.payload
      return arr
    case 'setUserListdataSourceLoadingAction':
      arr.userListdataSourceLoading = action.payload
      return arr
    case 'setUserListdataSourceAction':
      arr.userListdataSource = action.payload
      return arr
    case 'setSearchdataAction':
      // 搜索 重置 分页
      arr.searchdata = action.payload
      return arr
    case 'setDisabledOperateAction':
      arr.disabledOperate = action.payload
      return arr
    case 'setDisplayTipAction':
      arr.displayTip = action.payload
      return arr
    case 'setFillingSheetStateAction':
      arr.fillingSheetState = action.payload
      return arr
    case 'setIsImportModalVisibleAction':
      arr.isImportModalVisible = action.payload
      return arr
    case 'setIsImportModalConfirmBtnLoadingAction':
      arr.isImportModalConfirmBtnLoading = action.payload
      return arr
    case 'setUploadFilesListAction':
      arr.uploadFilesList = action.payload
      return arr
    case 'setOriginFileAction':
      arr.originFile = action.payload
      return arr
    case 'setImportLoadingTipAction':
      arr.importLoadingTip = action.payload
      return arr
    case 'setDockingSalesJobNumberAction':
      arr.dockingSalesJobNumber = action.payload
      return arr
    case 'setPlatformListAction':
      arr.platformList = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    default:
      return state
  }
}

// 设置Table数据
export const setDataSourceAction = (param: any[]): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

export const setDeleteParamAction = (
  param: string[],
): CustomAction<Action> => ({
  type: 'setDeleteParamAction',
  payload: param,
})

export const setGoodsCodeAction = (param: number): CustomAction<Action> => ({
  type: 'setGoodsCodeAction',
  payload: param,
})

export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

// 选择员工弹窗
export const setStaffModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setStaffModalVisibleAction',
  payload: param,
})

// loading
export const setUserListdataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setUserListdataSourceLoadingAction',
  payload: param,
})

// 设置数据
export const setUserListdataSourceAction = (
  param: oaUserItem[],
): CustomAction<Action> => ({
  type: 'setUserListdataSourceAction',
  payload: param,
})

// 搜索
export const setSearchdataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchdataAction',
  payload: param,
})

// 页面表单是否禁用
export const setDisabledOperateAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDisabledOperateAction',
  payload: param,
})

// 商品明细提示
export const setDisplayTipAction = (param: boolean): CustomAction<Action> => ({
  type: 'setDisplayTipAction',
  payload: param,
})

// 报备单状态
export const setFillingSheetStateAction = (param: {
  state: string
  approvalOpinion: string
}): CustomAction<Action> => ({
  type: 'setFillingSheetStateAction',
  payload: param,
})

// 导入弹窗显隐
export const setIsImportModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalVisibleAction',
  payload: param,
})

// 导入弹窗提交按钮loading
export const setIsImportModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalConfirmBtnLoadingAction',
  payload: param,
})

// 设置上传附件列表
export const setUploadFilesListAction = (
  param: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: param,
})

// 设置源文件
export const setOriginFileAction = (param: any): CustomAction<Action> => ({
  type: 'setOriginFileAction',
  payload: param,
})

//
export const setImportLoadingTipAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setImportLoadingTipAction',
  payload: param,
})

export const setDockingSalesJobNumber = (
  param: string,
): CustomAction<Action> => ({
  type: 'setDockingSalesJobNumberAction',
  payload: param,
})

export const setPlatformListAction = (param: any[]): CustomAction<Action> => ({
  type: 'setPlatformListAction',
  payload: param,
})

// 重新加载状态（用于恢复缓存）
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
/*
 * @Descripttion: 商品报备页State
 * @Author: cb4786
 * @Date: 2023-08-30 09:49:12
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-12-17 15:01:09
 */

import { ActionType, CustomAction } from '../../global'
import { oaUserItem } from '../../api/Filing'
import { SearchItem } from '../../components/Search'
import { fileFile } from '../../modules/uploadfiles/hooks'

export interface State {
  dataSource: any[]
  dataSourceLoading: boolean
  deleteParam: any[]
  goodsCode: number
  staffModalVisible: boolean
  searchdata: SearchItem
  userListdataSource: oaUserItem[]
  userListdataSourceLoading: boolean
  disabledOperate: boolean
  displayTip: boolean
  fillingSheetState: { state: string; approvalOpinion: string }
  isImportModalVisible: boolean
  isImportModalConfirmBtnLoading: boolean
  uploadFilesList: fileFile[]
  originFile: any
  importLoadingTip: boolean
  dockingSalesJobNumber: string
  platformList: any[]
}
export const defaultState: State = {
  dataSource: [],
  dataSourceLoading: false,
  deleteParam: [],
  goodsCode: 0,
  staffModalVisible: false,
  searchdata: {},
  userListdataSource: [],
  userListdataSourceLoading: false,
  disabledOperate: false,
  displayTip: false,
  fillingSheetState: { state: '审核中', approvalOpinion: '' },
  isImportModalVisible: false,
  isImportModalConfirmBtnLoading: false,
  uploadFilesList: [],
  originFile: {},
  importLoadingTip: false,
  dockingSalesJobNumber: '',
  platformList: [],
}

type Action = ActionType<State>

// 默认 Reducer
export default function reducer(state: State, action: CustomAction<Action>) {
  let arr = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      arr.dataSource = action.payload
      return arr
    case 'setGoodsCodeAction':
      arr.goodsCode = action.payload
      return arr
    case 'setDeleteParamAction':
      arr.deleteParam = action.payload
      return arr
    case 'setDataSourceLoadingAction':
      arr.dataSourceLoading = action.payload
      return arr
    case 'setStaffModalVisibleAction':
      arr.staffModalVisible = action.payload
      return arr
    case 'setUserListdataSourceLoadingAction':
      arr.userListdataSourceLoading = action.payload
      return arr
    case 'setUserListdataSourceAction':
      arr.userListdataSource = action.payload
      return arr
    case 'setSearchdataAction':
      // 搜索 重置 分页
      arr.searchdata = action.payload
      return arr
    case 'setDisabledOperateAction':
      arr.disabledOperate = action.payload
      return arr
    case 'setDisplayTipAction':
      arr.displayTip = action.payload
      return arr
    case 'setFillingSheetStateAction':
      arr.fillingSheetState = action.payload
      return arr
    case 'setIsImportModalVisibleAction':
      arr.isImportModalVisible = action.payload
      return arr
    case 'setIsImportModalConfirmBtnLoadingAction':
      arr.isImportModalConfirmBtnLoading = action.payload
      return arr
    case 'setUploadFilesListAction':
      arr.uploadFilesList = action.payload
      return arr
    case 'setOriginFileAction':
      arr.originFile = action.payload
      return arr
    case 'setImportLoadingTipAction':
      arr.importLoadingTip = action.payload
      return arr
    case 'setDockingSalesJobNumberAction':
      arr.dockingSalesJobNumber = action.payload
      return arr
    case 'setPlatformListAction':
      arr.platformList = action.payload
      return arr
    case 'reloadStateAction':
      arr = action.payload
      return arr
    default:
      return state
  }
}

// 设置Table数据
export const setDataSourceAction = (param: any[]): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

export const setDeleteParamAction = (
  param: string[],
): CustomAction<Action> => ({
  type: 'setDeleteParamAction',
  payload: param,
})

export const setGoodsCodeAction = (param: number): CustomAction<Action> => ({
  type: 'setGoodsCodeAction',
  payload: param,
})

export const setDataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDataSourceLoadingAction',
  payload: param,
})

// 选择员工弹窗
export const setStaffModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setStaffModalVisibleAction',
  payload: param,
})

// loading
export const setUserListdataSourceLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setUserListdataSourceLoadingAction',
  payload: param,
})

// 设置数据
export const setUserListdataSourceAction = (
  param: oaUserItem[],
): CustomAction<Action> => ({
  type: 'setUserListdataSourceAction',
  payload: param,
})

// 搜索
export const setSearchdataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchdataAction',
  payload: param,
})

// 页面表单是否禁用
export const setDisabledOperateAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setDisabledOperateAction',
  payload: param,
})

// 商品明细提示
export const setDisplayTipAction = (param: boolean): CustomAction<Action> => ({
  type: 'setDisplayTipAction',
  payload: param,
})

// 报备单状态
export const setFillingSheetStateAction = (param: {
  state: string
  approvalOpinion: string
}): CustomAction<Action> => ({
  type: 'setFillingSheetStateAction',
  payload: param,
})

// 导入弹窗显隐
export const setIsImportModalVisibleAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalVisibleAction',
  payload: param,
})

// 导入弹窗提交按钮loading
export const setIsImportModalConfirmBtnLoadingAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setIsImportModalConfirmBtnLoadingAction',
  payload: param,
})

// 设置上传附件列表
export const setUploadFilesListAction = (
  param: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: param,
})

// 设置源文件
export const setOriginFileAction = (param: any): CustomAction<Action> => ({
  type: 'setOriginFileAction',
  payload: param,
})

//
export const setImportLoadingTipAction = (
  param: boolean,
): CustomAction<Action> => ({
  type: 'setImportLoadingTipAction',
  payload: param,
})

export const setDockingSalesJobNumber = (
  param: string,
): CustomAction<Action> => ({
  type: 'setDockingSalesJobNumberAction',
  payload: param,
})

export const setPlatformListAction = (param: any[]): CustomAction<Action> => ({
  type: 'setPlatformListAction',
  payload: param,
})

// 重新加载状态（用于恢复缓存）
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
